import isDemo from '@/lib/utils/is_demo';
import { httpPut } from '../rest';

export function unlinkClientFromAdvisor(httpPut, isDemo) {
  return {
    async execute(unlinkedClientId) {
      /* istanbul ignore if */

      if (isDemo()) {
        return unlinkedClientId;
      }

      const response = await httpPut(`/clients/${unlinkedClientId}/unlink`);
      return response.data.id;
    },
  };
}

export default unlinkClientFromAdvisor(httpPut, isDemo);
